export default __webpack_public_path__ + "static/media/more.57f0be69.svg";